// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__K1GL+","root":"Sidebar_root__kINhX","closeButton":"Sidebar_closeButton__gest8","header":"Sidebar_header__pb66y"};